/**
 * @author zjl
 * @description 公共函数定义
 */
export const StringUtil = {
    trimToEmpty(str) {
        if (str == undefined || str == "undefined" || !str) {
            return '';
        } else {
            return str;
        }
    },
    isEmpty(str) {
        if (str == undefined || str == null || str == "" || str.trim() == "" || !str) {
            return true;
        }
        return false;
    },
    // 获取浏览器地址栏参数值
    getUrlParam(name) {
        let reg = new RegExp('(^|&)' + name + '=([^&]*)');
        let r = window.location.search.substr(1).match(reg);
        if (r)
            return decodeURIComponent(r[2]);
    },
    // 获取浏览器地址栏参数值
    getUrlParamHash(num,name) {
        let reg = new RegExp('(^|&)' + name + '=([^&]*)');
        let r = window.location.hash.substr(num).match(reg);
        if (r)
            return decodeURIComponent(r[2]);
    }
}
export const Cookies = {
    get(key) {
        return $cookies.get(key);
    },
    set(key, value) {
        $cookies.set(key, value, 60 * 60 * 24);
    }
}



// WEBPACK FOOTER //
// ./src/util/index.js